<div class="card-wrapper" role="region" aria-labelledby="voucher-heading">
<div class="voucher-card-image d-lg-none" aria-hidden="true">
    <img [src]="'vouchers/vouchermobile.svg' | contentAssetImage" alt="" />
  </div>

  <div class="voucher-card">
    <div class="voucher-info">
      <h2 class="voucher-title text-white" id="voucher-heading">
        {{ 'voucher.title' | translate }}
      </h2>
      <p class="text-white voucher-body" id="voucher-desc">
        {{ 'voucher.description' | translate }}
      </p>
    </div>

    <div class="voucher-input-group">
      <div class="voucher-row">
        <div class="voucher-input-wrap">
          <label for="voucher-input" class="sr-only">{{ 'voucher.title' | translate }}</label>
          <input
            id="voucher-input"
            class="voucher-input text-white bg-glass-dark"
            type="text"
            placeholder="Enter Code"
            [(ngModel)]="voucherCode"
            [attr.aria-invalid]="isInvalid() || null"
            aria-describedby="voucher-status"
            autocomplete="off"
            spellcheck="false"
            (keydown.enter)="redeemVoucher()"
          />
        </div>

        <button
          class="voucher-btn font-size-14 font-heading"
          type="button"
          (click)="redeemVoucher()"
          [disabled]="isLoading()"
          [attr.aria-busy]="isLoading() || null"
          aria-describedby="voucher-heading"
        >
          {{ isLoading() ? 'Applying...' : ('voucher.button' | translate) }}
        </button>
      </div>

      @if (status()) {
        <div class="status-pill" [ngClass]="'status-pill-' + variantType()" role="status">
          <span class="status-icon material-icons">{{ statusIcon() }}</span>
          <span>{{ statusMessage() }}</span>
        </div>
      }
    </div>

    <div id="voucher-status" class="sr-only" aria-live="polite" aria-atomic="true">
      {{ statusMessage() }}
    </div>
  </div>

  <div class="voucher-card-image gift-wrapper d-none d-lg-flex ms-5" aria-hidden="true">
    <div class="gift-image-container">
      <img [src]="'vouchers/voucher.svg' | contentAssetImage" alt="" class="gift-image" />
    </div>
  </div>
</div>
